// components/Top.js
import "./Top.css";
import leftArrow from "../assets/left-arrow.png";
import React, { useState } from "react";
import useApiService from "../hooks/useApiService.js";
import TopOutfitsDashboard from "../components/dashboard/TopOutfitsDashboard.js";
import TopProductsDashboard from "../components/dashboard/TopProductsDashboard.js";
import SalesDashboard from "../components/dashboard/SalesDashboard.js";
import CommissionsDashboard from "../components/dashboard/CommissionsDashboard.js";
import Outfit from "./produit.js";

function Top() {
  const [selectedOutfit, setselectedOutfit] = useState(null);
  const [selectedProduct, setselectedProduct] = useState(null);

  const { data: Outfitslist, loading: loadingOutfits } = useApiService(
    "api/influencer_platform/metrics/top_outfits",
    "GET"
  );

  const { data: Productslist, loading: loadingProducts } = useApiService(
    "api/influencer_platform/metrics/top_items",
    "GET"
  );

  const { data: SellsByDate, loading: loadingSells } = useApiService(
    "api/influencer_platform/metrics/sell_by_date",
    "GET"
  );

  const [ventesDashboardText, setventesDashboardText] = useState("Month");
  const [commissionDashboardText, setCommissionDashboardText] = useState("Month");

  const handleOutfitClick = (item) => {
    setselectedOutfit(item);
  };

  const handleProductClick = (item) => {
    setselectedProduct(item);
  };

  const handleDashboardClick = (index, type) => {
    if (index === "0") {
      setventesDashboardText(type);
    } else {
      setCommissionDashboardText(type);
    }
  };

  const DashboardStyle = (index, text) => {
    if (index === "0") {
      return {
        color: ventesDashboardText === text ? "rgb(65, 65, 65)" : "#888888",
        fontSize: "15px",
      };
    } else {
      return {
        color: commissionDashboardText === text ? "rgb(65, 65, 65)" : "#888888",
        fontSize: "15px",
      };
    }
  };

  if (loadingOutfits || loadingProducts || loadingSells) {
    return <h4>Loading...</h4>;
  }

  return (
    <>
      {selectedOutfit ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <img
            style={{
              width: "30px",
              height: "30px",
              marginLeft: "50px",
              marginTop: "30px",
              alignSelf: "flex-start",
            }}
            src={leftArrow}
            alt="backbutton"
            onClick={() => setselectedOutfit(null)}
          />
          <Outfit
            top={selectedOutfit.top}
            heart={selectedOutfit.heart}
            ventes={selectedOutfit.ventes}
            commission={selectedOutfit.commission}
            produit={selectedOutfit.produit}
          />
        </div>
      ) : (
        <>
          <TopOutfitsDashboard outfitsList={Outfitslist} handleOutfitClick={handleOutfitClick} />
          <TopProductsDashboard productsList={Productslist} handleProductClick={handleProductClick} />
          <SalesDashboard index="0" dashboardText={ventesDashboardText} handleDashboardClick={handleDashboardClick} dataList={SellsByDate} />
          <CommissionsDashboard index="0" dashboardText={commissionDashboardText} handleDashboardClick={handleDashboardClick} dataList={SellsByDate} />
        </>
      )}
    </>
  );
}

export default Top;
